module.exports = __webpack_public_path__ + "static/media/logo.eea295cb.jpg";